'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { ProductsContainer } from '../product-container';

export const ProductRecomendedProducts = () => {
  const { t } = useTranslations();
  const templateSettings = useGlobalStore(s => s.templateSettings);
  const product = useVariantsStore(s => s.product);

  const related = useRelatedProducts(product.slug);
  const relatedProducts = related.products;
  const isRecommendedAccessoriesEnabled =
    !!templateSettings.product_detail?.product_recommended_accessories?.enabled;
  const accessories = isRecommendedAccessoriesEnabled ? (product.accessories ?? []) : [];

  const hasRelatedProducts = relatedProducts.length > 0;
  const hasAccessories = accessories.length > 0;

  // Display nothing if:
  // - there are no related products AND
  // - (recommended accessories are disabled OR there are no accessories)
  if (
    !hasRelatedProducts &&
    (!isRecommendedAccessoriesEnabled || !hasAccessories) &&
    !related.isLoading &&
    !related.isError
  ) {
    return null;
  }

  // Merge accessories (first) + related products and dedupe by id
  const mergedProducts = [...accessories, ...relatedProducts];

  const seenIds = new Set<number | string>();
  const productsToShow = mergedProducts.filter((item: any) => {
    const id = item?.id;
    if (id == null) return false;
    if (seenIds.has(id)) return false;
    seenIds.add(id);
    return true;
  });

  return (
    <>
      {' '}
      <ProductsContainer
        products={productsToShow as any}
        title={t('text60')}
        description={t('text3838')}
        variant="carousel"
        className={{ section: 'pb-6 pt-12 sm:pb-8 sm:pt-16 md:pb-10 md:pt-20 lg:pb-12 lg:pt-24' }}
      />{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
};
